import { Traveler} from './traveler.model';
import { Country } from './country.model';
import { Flight } from './flight.model';
import { BillingInformation } from './billing-information.model';
import { Coverage } from './../../shared';
import { IApiAcknowledgement, ApiCoverageGroups } from '@bhtp-client-api/base';

export class PurchaseData {
    public agentCode: string;
    public agencyCode: string;
    public ratingId: string;
    public sessionId: number;
    public eventId: number;
    public quoteId: string;
    public quoteNumber: string;
    public customerId; string;

    public residenceState: string;
    public residenceStateName: string;
    public postalCode: string;
    public departureDate: string;
    public returnDate: string;
    public depositDate: string;
    public destination: string;
    public destinationCountry: Country = new Country();
    public destinationState: string;
    public destinationCity: string;

    public purchaseForOther: boolean = false;
    public policyBuyer: Traveler = null;
    public primaryTraveler: Traveler = new Traveler(true);
    public additionalTravelers: Array<Traveler> = new Array<Traveler>();

    public flights: Array<Flight> = new Array<Flight>();
    public acknowledgements: Array<IApiAcknowledgement> = new Array<IApiAcknowledgement>();

    public futureFlightsExpected: boolean;
    public overrideRequiresFlights: boolean;

    public rentalCarReturnDate: string;
    public rentalCarPickupDate: string;

    public selectedCoverages: Array<Coverage> = new Array<Coverage>();
    public availableCoverages: ApiCoverageGroups;
    public previouslySelectedCoverages: Array<Coverage> = new Array<Coverage>();
    public documentUrl: string;

    public billing: BillingInformation = new BillingInformation();

    public updateQuoteMessage: string;

    // Trip Suppliers
    public airline: string;
    public airlineNotProvided: boolean;
    public carRentalCompany: string;
    public cruiseLine: string;
    public hotel: string;
    public rentalCompany: string;
    public tourOperator: string;

    constructor() { }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/purchase-data.model.ts